import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage } from "../../elements";
import "./style.scss";
import { gtag } from "../../utils";
import gsap from 'gsap';
import { debounce } from "lodash";

const Typewriting = props => {
	const { lang, rendering, fields, page } = props;
	const { pc_text, m_text, pc_background_image, m_background_image} = fields;
	const isMobile = mobileIs()
	const rootNode = useRef()
	const whiteTextNode = useRef()
	const [isActive, setIsActive] = useState(false);
	const isAR = page?.fields?.rtl?.value;
	
	useEffect(() => {
		let wordDoms = document.querySelectorAll('.word');
		let length = wordDoms.length;
		if(isActive) {
			for(let i=0;i<length;i++) {
				wordDoms[i].style.transitionDelay = (length - i) * 0.03 + 's';
			}
		} else {
			for(let i=0;i<length;i++) {
				wordDoms[i].style.transitionDelay = i * 0.03 + 's';
			}
		}
	},[isActive]);
	
  useEffect(() => {
		let text = isMobile ? m_text : pc_text;
		let length = text.value.length;
		for(let i=0;i<text.value.length;i++) {
			let node = document.createElement("span");
			node.classList.add(`word_${i}`);
			node.innerHTML = text.value[i];
			whiteTextNode.current.appendChild(node)
		}
		
		let ScrollMagic, controller, scene, tl;
		ScrollMagic = loadScrollMagic()
		controller = new ScrollMagic.Controller()
		tl = gsap.timeline()
		
		for (let i = 0; i < length; i++) {
		  tl.add(gsap.to(`.word_${i}`, {
				opacity: 1
		  }), i)
		}
		
		scene = new ScrollMagic.Scene({
		  triggerElement: rootNode.current,
		  triggerHook: 0,
			offset: isMobile ? -window.innerHeight + 90 : -window.innerHeight + 240,
			duration: isMobile ? window.innerHeight : window.innerHeight * 1.2
		})
		.setTween(tl)
		.addTo(controller)
		
    return () => {
			scene.destroy(true);
			scene = null;
			controller.destroy(true);
			controller = null;
    };
  }, []);
	
	const rootClasses = classNames("c-typewriting", isActive ? 'active' : '', getOverallSettingsClasses(fields));
	let backgroundImage = isMobile ? m_background_image : pc_background_image;
	return (
		<div ref={rootNode}>
			<BackgroundImage className={rootClasses} {...backgroundImage}  datasourceid={rendering.dataSource}>
				<RichText className="c-typewriting_grey" tag="div" field={pc_text} />
				<div className="c-typewriting_white" ref={whiteTextNode}></div>
			</BackgroundImage>
		</div>
	)
}

export default 	Typewriting;